"use strict";

var upperCase = require('lodash/upperCase');

module.exports = function (accumulator, order, product, component, component_options, options) {
  var addition = upperCase(component.paper);

  if (component.envelope_color && component.envelope_color !== 'Paper') {
    var paperConversions = {};
    options.printers.printingPlus.paperTypes.forEach(function (_ref) {
      var value = _ref.value,
          actual = _ref.actual;
      paperConversions[value] = actual;
    });
    var pseudoPaperType = component.envelope_color;

    if (!paperConversions[pseudoPaperType]) {
      console.warn("".concat(pseudoPaperType, " did not match a real paper type. Check options.paperTypes"));
    }

    var realPaperType = paperConversions[pseudoPaperType] || pseudoPaperType;
    addition = upperCase(realPaperType);
  }

  if (accumulator.length) {
    return accumulator + ' ' + addition;
  }

  return accumulator + addition;
};